import { useCallback } from 'react';

import { ColorSelect } from '@/lib/crm/utils/colors/ColorSelect';

import type { PropertyInputProps } from './TextInput';

export const ColorSelectInput: React.FC<PropertyInputProps> = ({
  propertyType,
  value,
  onChange,
  disabled = false,
  placeholder,
}) => {
  const handleChange = useCallback(
    (colorValue: string | null) => {
      onChange(colorValue);
    },
    [onChange]
  );

  return (
    <ColorSelect
      value={typeof value === 'string' ? value : null}
      onChange={handleChange}
      isDisabled={disabled}
      placeholder={placeholder ?? 'Select color'}
      aria-label={propertyType.label}
    />
  );
};
